import Pagination from '@mui/material/Pagination';
import { useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ColorRing } from 'react-loader-spinner';
import { ClearSession } from '../../Common/Common';
import { Link } from 'react-router-dom';

import { Cookies } from 'react-cookie';
const cookies = new Cookies();

const PickupMasterReportTable = ({ loading, currentPageNo, handleChange, setColoredRow, ColoredRow, tableData, handleClick  }) => {
    const [SessionClear, SetSessionClear] = useState(false);
  
    const handleHighlight = (id) => {
        setColoredRow(id)
    }
    const countNo = Math.ceil((parseInt(tableData.totalRecord) / parseInt(tableData.pageSize)))

  
    return (
        <>
            <section className="recoard-table mt-3">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box d-block d-sm-flex">
                                <div className="heading mt-3">
                                    <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                        {tableData.totalRecord !== undefined && tableData.totalRecord !== null ?
                                            (`Total Records : ${tableData.totalRecord}`)
                                            :
                                            (`No record found`)}
                                    </h6>
                                </div>
                      
                            </div>
                            <div className="recoard-bata service-content-area">
                                {!loading ?
                                    (
                                        <>
                                            <div className="table-responsive">
                                                {tableData?.length !== 0 ?
                                                    (
                                                        tableData?.totalRecord !== null ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top">
                                                                <tr>
                                                                    <th>{tableData.hEvent}</th>
                                                                    <th>{tableData.hCustodian}</th>
                                                                    <th>{tableData.hClientRepresentative}</th>
                                                                    <th>{tableData.hVenue}</th>
                                                                    <th>{tableData.hTrunkID}</th>
                                                                    <th>{tableData.hStatus}</th>
                                                                    <th>{tableData.hUser}</th>
                                                                    <th>{tableData.hDistrict}</th>
                                                                    <th>{tableData.hAssignedTo}</th>
                                                                    <th>{tableData.hLatitude}</th>
                                                                    <th>{tableData.hLongitude}</th>
                                                                    <th>{tableData.hCreatedBy}</th>
                                                                    <th>{tableData.hCreatedDate}</th>
                                                                    <th>{tableData.hModifiedBy}</th>
                                                                    <th>{tableData.hModifiedDate}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableData?.getPickUpMasterReportData !== null ?
                                                                    (
                                                                        (tableData?.getPickUpMasterReportData)?.map((pickup, index) => (
                                                                            <tr key={index} onClick={() => handleHighlight(pickup.pickUpMasterID)} style={{ background: pickup.pickUpMasterID === ColoredRow ? '#cbe2ff' : '' }} >
                                                                                <td>{pickup.event}</td>
                                                                                <td>{pickup.custodian}</td>
                                                                                <td>{pickup.clientRepresentative}</td>
                                                                                <td>{pickup.venue}</td>
                                                                                <td><Link onClick={() => { handleClick(pickup.trunkID) }}>
                                                                                    {pickup.trunkID}</Link>
                                                                                </td>
                                                                                <td>{pickup.pickUpStatus}</td>
                                                                                <td>{pickup.user}</td>
                                                                                <td>{pickup.district}</td>
                                                                                <td>{pickup.assignedTo}</td>
                                                                                <td>{pickup.latitude}</td>
                                                                                <td>{pickup.longitude}</td>
                                                                                <td>{pickup.createdBy}</td>
                                                                                <td>{pickup.createdDate}</td>
                                                                                <td>{pickup.modifiedBy}</td>
                                                                                <td>{pickup.modifiedDate}</td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (<></>)}
                                                            </tbody>
                                                        </table>) : (<></>)

                                                    ) : (<></>)}
                                            </div>
                                            {countNo > 1 ?
                                                        <Pagination count={countNo} variant="outlined" page={currentPageNo} onChange={handleChange} shape="rounded" />

                                                : ''}
                                        </>
                                    ) : (
                                        <div className='d-flex align-items-center justify-center'>
                                            <ColorRing
                                                visible={true}
                                                height="80"
                                                width="80"
                                                ariaLabel="blocks-loading"
                                                wrapperStyle={{}}
                                                wrapperClass="blocks-wrapper"
                                                colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                                            />
                                        </div>
                                    )
                                }
                                {SessionClear ? <ClearSession /> : <></>}
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    )
}
export default PickupMasterReportTable;
